<h2>In 't kort</h2>

Ons grote voorbeeld qua bouw en uitstraling: Jolimont Warrior

<img src="/assets/images/pages/jolimont_warrior.jpg" alt="Jolimont Warrior">

Zullen we dit ooit overtreffen? Wereld record 2011 'Ultrafijne wol' van 17,8 micron

<img src="/assets/images/pages/micron.png" alt="Alpaca fleece">

Wij bieden hulp aan Alpacashows in Nederland

<a href="http://www.alpaca-benelux.com" target="_blank">
    <img src="/assets/images/pages/aab_logo.png" alt="Alpaca Association Benelux (AAB)">
</a>

Wij zijn supporter van de CameliDynamics methode en hebben zelf de driedaagse basiscursus gedaan in 2012.

<a href="http://www.camelidynamics.com" target="_blank">
    <img src="/assets/images/pages/camelidynamics.jpg" alt="CameliDynamics">
</a>

Volg ons op <a href="https://www.facebook.com/pages/Alpaca-fokkerij-Alpacamundo/206931986065876?sk=wall" target="_blank">Facebook</a>

<a href="https://www.facebook.com/pages/Alpaca-fokkerij-Alpacamundo/206931986065876?sk=wall" target="_blank">
    <img src="/assets/images/pages/facebook.png" alt="Facebook Alpacamundo">
</a>